import { CompOffService } from './compOffService';
import { OvertimeService } from './overtimeService';

/*
 * generateEmployeeSummaryReport is gone, along with the LeaveReportsModal that was its only
 * caller (itself unreachable — nothing imported it).
 *
 * It was a second implementation of the balance maths, and a wrong one. It hardcoded
 * mlGranted to 180, initialised coEarned to 0 so Comp-Off could only ever read zero or
 * negative, ignored HR adjustments entirely, and built rows by iterating leave requests —
 * so an employee who had taken no leave simply did not appear in the report. It also keyed
 * on email.toLowerCase() rather than canonicalizeEmail, splitting anyone whose records
 * straddle the domain move.
 *
 * The note on LeaveBalanceService.getBalancesForAll describes those exact faults as having
 * been removed; the function survived the change and would have re-introduced every one of
 * them the moment anything called it. Reports now goes through getBalancesForAll, which is
 * the same computeSnapshotsFor the employee's own dashboard uses.
 *
 * What remains here are the two pass-throughs that are genuinely report-only: Comp-Off and
 * Overtime record listings. Both are cache reads — callers refresh first (see
 * LeaveReportsPage.load).
 */
export class LeaveReportService {
  static getCompOffReport() {
    return CompOffService.getRecords();
  }

  static getOvertimeReport() {
    return OvertimeService.getRecords();
  }
}
